import { useState } from 'react';

import DeleteOutline from '@mui/icons-material/DeleteOutlined';
import { Box, Typography } from '@mui/material';

import { Dialog, DialogButton } from '@/components/Dialog';
import presets from '@/components/Dialog/presets';
import { NameInput } from '@/components/NameInput';
import TypographyComponent from '@/components/Typography';
import { SymbolAlias } from '@/features/Dashboard/components/SymbolAlias';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';
import type { TabSymbol } from '@/features/Dashboard/form/AppForm/context/types';

const rootSx = { display: 'flex', alignItems: 'center' };
const contentSx = {
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  pr: 1
};
const deleteBtnSx = {
  display: 'flex',
  width: '32px',
  height: '32px',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'info.dark',
  border: 'none',
  outline: 'none',
  cursor: 'pointer',
  opacity: 1,
  ml: 'auto'
};
const deleteIconSx = { fontSize: 16, color: 'text.primary' };

export const SymbolContent = ({ symbol, index }: { symbol: TabSymbol; index: number }) => {
  const { updateSymbol, removeSymbol, form, setCanPreview } = useAppForm();
  const type = form.state.values?.type;

  const [isDelete, setIsDelete] = useState(false);

  return (
    <Box sx={rootSx}>
      <Box sx={contentSx}>
        <TypographyComponent size={14}>#{index + 1}</TypographyComponent>
        <TypographyComponent
          size={14}
          sx={{ width: 100, ml: 3 }}
        >
          <SymbolAlias
            symbol={symbol}
            type={type}
          />
        </TypographyComponent>

        <NameInput
          value={symbol.shortTitle}
          onBlur={() => {
            setCanPreview(true);
          }}
          onChange={val => {
            updateSymbol({
              ...symbol,
              shortTitle: val
            });
          }}
          onFocus={() => {
            setCanPreview(false);
          }}
        />
      </Box>
      <Box
        component='button'
        sx={deleteBtnSx}
        onClick={() => {
          setIsDelete(true);
        }}
      >
        <DeleteOutline sx={deleteIconSx} />
      </Box>
      <Dialog
        buttons={
          <>
            <DialogButton
              variant='outlined'
              onClick={() => {
                setIsDelete(false);
              }}
            >
              {presets.removeItem.cancelText}
            </DialogButton>
            <DialogButton
              variant='contained'
              onClick={() => {
                removeSymbol(symbol);
                setIsDelete(false);
              }}
            >
              {presets.removeItem.confirmText}
            </DialogButton>
          </>
        }
        open={isDelete}
        title={presets.removeItem.title}
        onClose={() => {
          setIsDelete(false);
        }}
      >
        <Typography>{presets.removeItem.text}</Typography>
      </Dialog>
    </Box>
  );
};
